import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

// Each crumb is an ancestor recipe the user drilled down from, carried in history state so the trail
// survives refresh and unwinds naturally with the browser back button.
const RecipeBreadcrumb = ({ trail, currentRecipeName, onCrumbClick }) => {
  if (!trail?.length) {
    return null;
  }

  const crumbTextStyle = {
    maxWidth: { xs: "120px", sm: "200px", md: "260px" },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <Box sx={{ marginTop: 1, marginBottom: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon sx={{ fontSize: 16 }} />}
        // collapses the middle of a long trail behind an expandable "..." so deep nesting
        // cannot push the crumbs off screen
        maxItems={4}
        itemsBeforeCollapse={1}
        itemsAfterCollapse={2}
        aria-label="recipe trail"
        sx={{
          "& .MuiBreadcrumbs-ol": { flexWrap: "nowrap" },
          "& .MuiBreadcrumbs-li": { minWidth: 0 },
        }}
      >
        {trail.map((crumb, index) => (
          <Link
            key={`${crumb.id}-${index}`}
            component="button"
            underline="hover"
            onClick={() => onCrumbClick(crumb, index)}
            sx={{
              ...crumbTextStyle,
              color: (theme) => theme.palette.primary[800],
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              fontSize: 14,
              display: "block",
              textAlign: "left",
            }}
          >
            {crumb.name || "Untitled Recipe"}
          </Link>
        ))}
        <Typography
          variant="body2"
          sx={{
            ...crumbTextStyle,
            color: (theme) => theme.palette.terrain[600],
          }}
        >
          {currentRecipeName}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

export default RecipeBreadcrumb;
